import * as React from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import './ProjectDetails.css';
import { Card } from '@mui/material';
import InstructorsCarousel from './InstructorsCarousel';

export default function Instructors(props) {
    const { isSmallScreen, setValue } = props;
    const [spacing, setSpacing] = React.useState(2);

    const handleChange = (event) => {
        setSpacing(Number(event.target.value));
    };

    const ref = React.useRef(null);

    React.useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setValue(6);
                }
            },
            { threshold: 0.9 }
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            if (ref.current) {
                observer.unobserve(ref.current);
            }
        };
    }, []);


    return (
        <div ref={ref} style={{ margin: isSmallScreen ? "4rem auto auto 20px" : "60px", marginBottom: "0px" }} id="ourInstructors">
            <span className={isSmallScreen ? 'only-heading-sm' : 'only-heading'}>Our  </span>
            <span className={isSmallScreen ? 'gradient-heading-sm' : 'gradient-heading'}>Instructors</span>
            <div style={{ marginTop: "0rem" }}>
                <InstructorsCarousel isSmallScreen={isSmallScreen} />
            </div>
        </div>
    );
}